<div class="progress-bar-container">
    <div class="logo-container">
        <img src="assets/img/phoenix-logo.png" alt="Logo" class="logo" />
    </div>
    <div class="steps-container">
        <div class="step" *ngIf="stepResponsive(1)" (click)="changeTest(1)">
            <span class="step-title" [ngClass]="{'active': currentStep >= 1}">Evaluación del presente</span>
            <div class="step-circle" [ngClass]="{'active': currentStep >= 1}">1</div>
        </div>
        <div class="espace-step-line">
            <div class="step-line-container">
                <div class="step-line" [ngClass]="{'active-line': currentStep >= 2}"></div>
                <!-- Línea de progreso para el primer paso -->
                <div class="progress-fill" *ngIf="currentStep == 1" [style.width.%]="percentageComplete"></div>
            </div>
        </div>
        <div class="step" *ngIf="stepResponsive(2)" (click)="changeTest(2)">
            <span class="step-title" [ngClass]="{'active': currentStep >= 2}">Evaluación del futuro</span>
            <div class="step-circle" [ngClass]="{'active': currentStep >= 2}">2</div>
        </div>
        <div class="espace-step-line">
            <div class="step-line-container">
                <div class="step-line" [ngClass]="{'active-line': currentStep >= 3}"></div>
                <!-- Línea de progreso para el segundo paso -->
                <div class="progress-fill" *ngIf="currentStep == 2" [style.width.%]="percentageComplete"></div>
            </div>
        </div>
        <div class="step" *ngIf="stepResponsive(3)" (click)="changeTest(3)">
            <span class="step-title" [ngClass]="{'active': currentStep >= 3}">Resultados</span>
            <div class="step-circle" [ngClass]="{'active': currentStep >= 3}">3</div>
        </div>
    </div>
</div>